import { PureComponent, ReactNode } from 'react';

import qs from 'qs';
import { connect } from 'react-redux';

import { Repository } from 'src/components/types';
import { LegacyRouteProps, Ref } from 'src/sections/repository/types';
import { getCurrentRepository } from 'src/selectors/repository-selectors';
import { BucketState } from 'src/types/state';

import { UNLOAD_SOURCE } from '../actions';
import loadSource from '../actions/load-source';

const mapDispatchToProps = {
  loadSource,
  unloadSource: () => ({ type: UNLOAD_SOURCE }),
};

const mapStateToProps = (state: BucketState) => ({
  currentRef: state.repository.source.section.ref,
  hash: state.repository.source.section.hash,
  repository: getCurrentRepository(state),
});

export type SourceSectionProps = LegacyRouteProps<{
  refOrHash?: string;
}> & {
  children: ReactNode;
  currentRef?: Ref;
  hash?: string;
  loadSource: typeof loadSource;
  repository: Repository | null | undefined;
  unloadSource: () => void;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  // TODO: Replace usage of unsafe lifecycle methods
  // eslint-disable-next-line react/no-unsafe
  class SourceSection extends PureComponent<SourceSectionProps> {
    componentDidMount() {
      this.loadSource(this.props);
    }

    /* eslint react/no-unsafe: "warn" */
    UNSAFE_componentWillReceiveProps(nextProps: SourceSectionProps) {
      const { repository } = this.props;
      const { repository: nextRepository } = nextProps;

      const isNewRepository =
        (repository &&
          nextRepository &&
          repository.uuid !== nextRepository.uuid) ||
        (!repository && nextRepository);

      if (isNewRepository || this.didUrlRefOrHashTargetChange(nextProps)) {
        this.loadSource(nextProps);
      }
    }

    componentWillUnmount() {
      this.props.unloadSource();
    }

    loadSource(props: SourceSectionProps) {
      const { search } = props.location;
      const queryParams = qs.parse(search, {
        ignoreQueryPrefix: true,
      });

      const { repositoryOwner, repositorySlug, refOrHash } = props.match.params;
      if (repositoryOwner && repositorySlug) {
        const repositoryFullSlug = `${repositoryOwner}/${repositorySlug}`;
        this.props.loadSource(
          { repositoryFullSlug, refOrHash },
          queryParams.at as string
        );
      }
    }

    didUrlRefOrHashTargetChange(nextProps: SourceSectionProps) {
      const { currentRef, hash, match, repository } = this.props;

      const urlRefOrHash = match.params.refOrHash;
      const nextUrlRefOrHash = nextProps.match.params.refOrHash;

      const refName = currentRef ? currentRef.name : null;
      const mainBranchName =
        repository && repository.mainbranch ? repository.mainbranch.name : null;
      const isMainBranch = !!(refName && refName === mainBranchName);

      const isNewUrlRefOrHash = urlRefOrHash !== nextUrlRefOrHash;

      // /src => (/src/<mainBranchNameOrHash> OR /src/<mainBranchHash>?at=<mainBranchName>)
      const isBaseUrlToMainBranch =
        !urlRefOrHash && !!nextUrlRefOrHash && isMainBranch;

      // (/src/<mainBranchNameOrHash> OR /src/<mainBranchHash>?at=<mainBranchName>) => /src
      const isMainBranchToBaseUrl = !nextUrlRefOrHash && isMainBranch;

      // (/src/refName => /src/refNameHEADHash)
      const isRefToHeadHash = hash === nextUrlRefOrHash;

      return (
        isNewUrlRefOrHash &&
        !isBaseUrlToMainBranch &&
        !isMainBranchToBaseUrl &&
        !isRefToHeadHash
      );
    }

    render() {
      return this.props.children || null;
    }
  }
);
